import axios from 'axios';
import { message } from 'antd';
import { initIam } from '../hook/iam';

// 创建axios实例
const request = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  },
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('haier-user-center-access-token');
    if (token) {
      config.headers['Access-Token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    console.log('response=====', response);
    return response.data;
  },
  async (error) => {
    console.log('error=====', error);
    if (error.response) {
      const { status } = error.response;
      
      // 处理401错误
      if (status === 401) {
        console.log('登录已过期，请重新登录');
        // 清除本地token
        localStorage.removeItem('haier-user-center-access-token');
        localStorage.removeItem('haier-user-center-user-info');
        
        try {
          // 重新登录
          const iamResult:any = await initIam();
          console.log('iamResult=====', iamResult);
          if (iamResult.success) {
            // 获取新token
            const newToken = iamResult.token;
            if (!!newToken && error.config) {
              // 更新请求的token
              error.config.headers['Access-Token'] = newToken;
              // 重试请求
              console.log('重试请求');
              console.log('error.config=====', error.config);
              return request(error.config);
            }
          }
        } catch (e) {
          console.error('重新登录失败:', e);
        }
      } else {
        // 处理其他错误
        message.error(error.response.data?.message || '请求失败，请稍后重试');
      }
    } else if (error.request) {
      message.error('网络请求失败，请检查网络连接');
    } else {
      message.error('请求发生错误，请稍后重试');
    }
    return Promise.reject(error);
  }
);

export default request; 